// Dev-only per-tab sessions.
//
// The AuthToken cookie is shared by every tab in a browser, so without this each
// tab would authenticate as the same player — making it impossible to test this
// multiplayer game with several tabs in one browser. In development the /register
// response also hands back the raw token; we stash it in sessionStorage (which,
// unlike cookies and localStorage, is isolated per browser tab) and send it via
// an Authorization header (HTTP) or a ?token= query param (WebSocket). Each tab
// then acts as its own player. In production this is inert: the server omits the
// token from the response and ignores the header/query, so the httpOnly cookie
// stays the only credential.
export const DEV_MULTI_SESSION = process.env.NODE_ENV === 'development';

const STORAGE_KEY = 'AuthToken';

export const getDevToken = (): string | null =>
  DEV_MULTI_SESSION ? window.sessionStorage.getItem(STORAGE_KEY) : null;

export const setDevToken = (token: string): void => {
  if (DEV_MULTI_SESSION) window.sessionStorage.setItem(STORAGE_KEY, token);
};

export const clearDevToken = (): void => {
  if (DEV_MULTI_SESSION) window.sessionStorage.removeItem(STORAGE_KEY);
};

// Append the per-tab token to a WebSocket URL so the upgrade authenticates as
// this tab's user (browsers can't set headers on a WebSocket). No-op in prod.
export const withDevToken = (url: string): string => {
  const token = getDevToken();
  if (!token) return url;
  const sep = url.includes('?') ? '&' : '?';
  return `${url}${sep}token=${encodeURIComponent(token)}`;
};
